<template>
    <div>
        <div v-if="erro">
            <SemPermissao></SemPermissao>
        </div>
        <template v-if="!erro">
            <OnusForm :onus="null" />
        </template>
    </div>
</template>

<script>
    import OnusForm from '../../components/onus/OnusForm.vue';
    import SemPermissao from "../SemPermissao.vue"
    
    //import ErroResultados from "../../components/ErroResultados";

    export default {
        name: "OnusNew",
        data() {
            return {
                erro: false,
            };
        },
        components: {
            SemPermissao,
            ////ErroResultados,
            OnusForm,
        },
    };
</script>

<style lang="scss" scoped>
</style>